import { memo, useEffect, useMemo, useState } from 'react';
import CharacterSpot from '../CharacterRoute/components/CharacterSpot';
import _ from 'lodash';
import { characterSpots, themeSpots } from '../CharacterRoute/instance';
import { animated, useTransition } from '@react-spring/web';
import { CharacterRoutePlaceInfo } from '@/store/types';
import BackgroundAnimate from '@/components/BackgroundAnimate';
import { useStore } from '@/store';
import { PageMode } from '@/store/types';
import { useQueryGetAllRouteData } from '@/services/hooks';
import QrCode from '@/components/QrCode';
import { driveDigitalHumanByText } from '@/pages/DigitalHuman/util/tts-manage';

const TravelLine = memo(() => {
  // const isCharacterRouteMode = useStore((state) => state.mode=== PageMode.CHARACTER_ROUTE) ;
  // const routeDetailId = useStore((state) => state.routeDetailId);
  const mode = useStore((state) => state.mode);
  // const indexRef = useRef(0);
  const [curIndex, setCurIndex] = useState(0);
  const [list, setList] = useState<CharacterRoutePlaceInfo[]>([]);

  const { data } = useQueryGetAllRouteData();

  useEffect(() => {
    if (mode === PageMode.ROUTE_THEME_LIST) {
      const arr: any = data?.themeList.map((item, index) => ({ ...item, x: themeSpots[index].x, y: 42 }));
      setList(arr);
    }
  }, [mode]);

  // 语音控制
  useEffect(()=>{
    driveDigitalHumanByText(`一湖碧水，多重境界。西湖主题万千，我们先看四种：从“语文课本”初识晴雨湖山；在《水浒传》找到隐藏的西湖风景；探寻西湖边俞樾、马一浮等文学名人故居；在岳飞庙和于谦祠，感受英雄之气的生生不息。`);
  },[])

  const transitions = useTransition(curIndex, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 500 },
  });

  // useEffect(() => {
  //   let timer: any = null;
  //   if (list.length > 1 && !routeDetailId) {
  //     timer = setInterval(() => {
  //       indexRef.current += 1;
  //       if (indexRef.current > list.length - 1) {
  //         indexRef.current = 0;
  //       }
  //       setCurIndex(indexRef.current);
  //     }, 10000);

  //     return () => {
  //       clearInterval(timer);
  //     }
  //   } else {
  //     return () => {
  //       clearInterval(timer);
  //     }
  //   }
  // }, [list, routeDetailId]);

  // console.log('isCharacterRouteMode', isCharacterRouteMode);
  return (
    <BackgroundAnimate visible={true} animate opacity={1} loop>
      {
        transitions((style, item) =>
          <animated.div style={{ ...style, width: '100%', height: '100%', position: 'relative' }}>
            {
              list?.map((spot, index) => (
                <CharacterSpot
                  key={spot.entity_id}
                  card={spot}
                  index={index}
                />
              ))
            }
          </animated.div>
        )
      }
      <QrCode />
    </BackgroundAnimate>
  );
});

export default TravelLine; 